module.exports = __webpack_public_path__ + "static/MT_Process-03.b71fd446.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-03.png
// module id = 1500
// module chunks = 214286880276331